<template>
    <div class="page locationPage">
        <Map/>
        <Sidebar/>
    </div>
</template>
<script>
    import Map from "../../components/locations/Map";
    import {mapState} from "vuex";
    import Sidebar from "../../components/locations/Sidebar";

    export default {
        name: 'Locations',
        components: {Sidebar, Map},
        created() {
            this.$store.commit("shared/setTopBar", {title: "In-Store Pickup", showLocationSearch: true});
        }
    }
</script>
